import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { ProfileService } from '../../shared/profile.service';
import { TokenService } from '../../shared/token.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AccountSharingEventType } from '../account-sharing-event-type';
import { GTMService } from '../../shared/gtm.service';
import { AccountSharingTrackEvents } from '../account-sharing-track-events';
import { isIFrameSameOrigin } from '../../shared/helpers/is-same-origin';
import { WindowService } from '../../shared/window.service';
import { SharedAccountService } from '../../login/shared-account.service';

@Component({
  selector: 'lp2-account-sharing-page',
  template: '<iframe *ngIf="src" id="account-sharing-iframe" [src]="src | safeUrl" frameborder="0" allow="microphone; autoplay; camera"></iframe>',
  styleUrls: ['./account-sharing-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountSharingPageComponent implements OnInit {

  public src: string = null;

  public getSrc(): Observable<string> | null {
    return this.profileService.address$.pipe(map((address) => {
      return `${this.oeAppService.webAccountSharingPageHost}?env=${this.oeAppService.environment}&accessToken=${this.tokenService.token}&countryId=${address.countryId}&lang=${this.oeAppPersonService.preferredLang}&personId=${this.oeAppPersonService.id}`;
    }));
  }

  constructor(
    private readonly oeAppService: OeAppService,
    private readonly oeAppPersonService: OeAppPersonService,
    private readonly profileService: ProfileService,
    private readonly tokenService: TokenService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly gtmService: GTMService,
    private readonly windowService: WindowService,
    private readonly sharedAccountService: SharedAccountService
  ) {
    window.addEventListener('message', this.handleEvents.bind(this), false);
  }

  ngOnInit(): void {
    this.getSrc().subscribe((src) => {
      this.src = src;
      this.cdRef.detectChanges();
    });
  }

  private handleEvents({ data, origin, source }) {
    if (isIFrameSameOrigin(window.location.href, origin)) {
      return;
    }
    switch (data.type) {
      case AccountSharingEventType.ACCOUNT_SHARING_SUCCESS_EVENT:
        this.sharedAccountService.removeSharingAccountPendingValidationValue();
        const url = this.sharedAccountService.getSharingAccountUrlValue();
        this.sharedAccountService.removeSharingAccountUrlValue();
        this.windowService.redirectToHref(url);
        break;
      case AccountSharingEventType.ACCOUNT_SHARING_TRACKING_EVENT:
        this.gtmService.sendGA4Event(data.data);
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./ts/app/account-sharing/account-sharing-page/account-sharing-page.component.ts